var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itemId)?_c('span',{class:{ 'wishlist-icon': !_vm.is_in_wishlist },style:({
        color: _vm.is_in_wishlist ? _vm.color : '',
    })},[_c('svg-icon',{key:_vm.wishlistIcon,attrs:{"name":_vm.wishlistIcon,"width":"32","height":"32"},on:{"click":_vm.toggleWishlist}})],1):_c('nuxt-link',{attrs:{"to":"/lk/favorites/","aria-label":_vm.$t('favorites')}},[_c('svg-icon',{key:_vm.wishlistIcon,style:({
            color: _vm.wishlist.length ? _vm.color : '',
        }),attrs:{"name":_vm.wishlistIcon,"width":"32","height":"32"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }